import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userNumber: null,
    RenWenScroll: 0,
    GuiLiScroll: 0,
    CEOScroll: 0,
    QiYeScroll: 0,
  },
  getters: {
    getUserNumber(state) {
      //console.log(state, '哈哈')
      return state.userNumber
    },
  },
  mutations: {
    setUserNumber(state, userNumber) {
      state.userNumber = userNumber
    },
    SET_RENWEN_SCROLL(state, payload) {
      state.RenWenScroll = payload;
    },
    SET_GUILI_SCROLL(state, payload) {
      state.GuiLiScroll = payload;
    },
    SET_CEO_SCROLL(state, payload) {
      state.CEOScroll = payload;
    },
    SET_QIYE_SCROLL(state, payload) {
      state.QiYeScroll = payload;
    },
  },
  actions: {
    initializeuserNumber({ commit }) {
      return new Promise((resolve) => {
        const storedNumber = localStorage.getItem('userNumber');
        if (storedNumber) {
          commit('setUserNumber', JSON.parse(storedNumber));
        } else {
          const newuserNumber = Date.now();
          commit('setUserNumber', newuserNumber);
          localStorage.setItem('userNumber', JSON.stringify(newuserNumber));
        }
        resolve(); // 确保在操作完成后调用 resolve
      });
    }
  },
  modules: {
  }
})
